
class AresConfig {
  constructor() {
    this.trpc = {
      newRequest: () => {},
    };
    this.logger = {
      uplog: () => {},
      uplogNow: () => {},
    };
    this.reporter = {};
    this.tools = {};
    this.jsbridge = {
      Ares: {
        getPlatform: () => {},
        getChannelId: () => {},
        login: () => {},
      },
    };
  }
  setConfig(payload) {
    Object.keys(payload).forEach((key) => {
      this[key] = payload[key];
    });
  }
}

const aresManager = new AresConfig();

export {
  aresManager,
};
